'use client';

import { c as _c } from "react/compiler-runtime";
import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import * as THREE from 'three';
interface SceneCanvasProps {
  children: React.ReactNode;
}
const SceneCanvas = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: [0, 0, 20],
      fov: 50
    };
    t2 = {
      antialias: false,
      alpha: true,
      powerPreference: "high-performance"
    };
    t3 = [1, 1];
    t4 = {
      min: 0.5
    };
    t5 = {
      pointerEvents: "auto"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <Canvas shadows={false} camera={t1} gl={t2} dpr={t3} performance={t4} style={t5}><Suspense fallback={null}>{children}</Suspense></Canvas>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default SceneCanvas;